import type { SVGProps } from 'react';

export const IdealIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={24}
    height={24}
    style={{
      opacity: 1,
    }}
    viewBox='0 0 640 640'
    {...props}
  >
    <path d='M157.8 229.5c-18.1-.8-35.1 8.4-44.4 23.9-9.2 15.5-9.2 34.8 0 50.3 9.3 15.5 26.3 24.7 44.4 23.9 18.1.8 35.1-8.4 44.4-23.9 9.2-15.5 9.2-34.8 0-50.3-9.3-15.5-26.3-24.7-44.4-23.9m-39.5 260.3h78.9V349.3h-78.9zm151.5-211.6c0-20-10-22.5-18.7-22.5h-14v45.8h14c9.7 0 18.7-2.8 18.7-23.3m201.7 46v-91.3h22.8v68.6H528c-9.4-124.4-107.2-151.3-196.2-151.3H237V233h14c25.6 0 41.5 17.4 41.5 45.3 0 28.8-15.5 46-41.5 46h-14v165.6h94.8c144.6 0 194.9-67.2 196.7-165.6h-57.1zm-109.8 0h-56.2V233h54.4v22.7h-31.7v10.6h30V289h-30v12.5h33.5zm74.7 0-5.2-17.7h-29.7l-5.2 17.7h-23.7l27.5-91.3h32.3l27.5 91.3h-23.7zM331.8 96H64.1v448h267.7c161.8 0 251-79.7 251-224.5 0-83.5-32.6-223.5-251-223.5m0 426.9H85.2V117h246.6c142.1 0 229.9 64.6 229.9 202.4 0 134.1-81 203.4-229.9 203.4zM415.7 258l-7.5 25.8h16.4l-7.5-25.8z' />
  </svg>
);
